import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import CheckInbox from './pages/CheckInbox';
import VerifyPage from './pages/VerifyPage';
import UploadPage from './pages/UploadPage';
import FallbackLoginPage from './pages/FallbackLoginPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/check-inbox" element={<CheckInbox />} />
      <Route path="/auth/verify" element={<VerifyPage />} />
      <Route path="/fallback-login" element={<FallbackLoginPage />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
